<template>
  <div
    class="modal fade"
    id="BulkServiceBundleChange"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-10 my-auto">
            <h5 class="modal-title" id="BulkServiceBundleChangeLabel">
              Bulk Service Bundle Change
            </h5>
          </div>
          <div class="col-2 my-auto">
            <span
              ><a class="close"
                ><i
                  class="far fa-times-circle fa-2x"
                  data-dismiss="modal"
                  id="closeBulkServBundleChange"
                  aria-label="Close"
                ></i></a
            ></span>
          </div>
        </div>
        <div class="modal-body">
          <div class="container-fluid">
            <!-- Import Section Start -->
            <div class="container-fluid no-pad">
              <div class="row text-center mt-3">
                <div class="col-sm-12">
                  <b-form-file
                    v-model="selected"
                    :state="Boolean(selected)"
                    accept=".csv"
                    ref="file-input"
                  />
                </div>
                <div class="col-sm-12 mt-4">
                  <button
                    type="submit"
                    class="btn btn-hc w-40 mr-2 mb-3"
                    @click.prevent="submit"
                    :disabled="submitStatus == 'PENDING'"
                  >
                    Import
                  </button>
                  <button
                    type="submit"
                    class="btn btn-hc w-40 ml-2 mb-3"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
            <!-- Import Section End -->
            <!-- Logs Section Start -->
            <div
              class="border border-light rounded bg-white brs mt-3 pl-3 pr-3"
            >
              <div class="row mt-3 mb-3">
                <div class="col-sm-4 col-md-6 col-xl-4">
                  <h4>Error Log</h4>
                </div>
                <!-- Search Filter Start -->
                <div class="col-sm-8 col-md-6 col-xl-4 offset-xl-4">
                  <div class="search_75">
                    <form class="input-group md-form form-sm">
                      <input
                        class="form-control form-control-sm search"
                        name="search"
                        placeholder="Search filenames..."
                        autocomplete="off"
                        type="text"
                        v-model="filenameSearch"
                      />
                      <div class="input-group-btn">
                        <i class="fa fa-search active" aria-hidden="true"></i>
                      </div>
                    </form>
                  </div>
                </div>
                <!-- Search Filter End -->
              </div>
              <!-- Date Filter Start -->
              <div class="row mt-3 mb-3">
                <div class="col-sm-12 bg-white brs pt-3 pb-2">
                  <div class="row dpmw">
                    <div class="col-12 col-sm-7 col-md-6">
                      <div class="row">
                        <div class="col-sm-6">
                          <a
                            @click="last30Days"
                            role="button"
                            class="btn btn-hc-outline btn-block no-pad"
                            >Last 30 days</a
                          >
                        </div>
                        <div class="col-sm-6">
                          <a
                            @click="last6Months"
                            role="button"
                            class="btn btn-hc-outline btn-block no-pad"
                            >Last 6 months</a
                          >
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6 mt-2">
                          <a
                            @click="last12Months"
                            role="button"
                            class="btn btn-hc-outline btn-block no-pad"
                            >Last 12 months</a
                          >
                        </div>
                        <div class="col-sm-6 mt-2">
                          <a
                            @click="resetFilter"
                            role="button"
                            class="btn btn-hc-outline btn-block no-pad"
                            >Reset filters</a
                          >
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6 mt-2">
                          <a
                            @click="$store.dispatch('getServiceBundleLogs')"
                            role="button"
                            class="btn btn-primary btn-block no-pad"
                            >Refresh Logs</a
                          >
                      </div>
                      </div>
                    </div>
                    <div class="col-12 col-sm-5 col-md-6">
                      <div class="row">
                        <div class="col-sm-12">
                          <el-date-picker
                            v-model="startDate"
                            format="dd.MM.yyyy"
                            type="date"
                            placeholder="Select a start date"
                          ></el-date-picker>
                        </div>
                        <div class="col-sm-12">
                          <el-date-picker
                            class="my-2"
                            v-model="endDate"
                            format="dd.MM.yyyy"
                            type="date"
                            placeholder="Select an end date"
                          ></el-date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Date Filter End -->
              <!-- Table Start -->
              <div
                class="table-responsive-lg pre-scrollable tfh"
                v-if="serviceBundleLogs.length > 0"
              >
                <b-table striped :items="filteredLogs" :fields="errorLogFields">
                  <template slot="LoggedAt" slot-scope="data">
                    {{ data.item.LoggedAt | moment("DD.MM.YYYY HH:mm") }}
                  </template>
                  <template slot="RecordIdentifier" slot-scope="data">
                    {{ data.item.RecordIdentifier }}
                  </template>
                  <template slot="Message" slot-scope="data">
                    {{ data.item.Message }}
                  </template>
                  <template slot="Guidance" slot-scope="data">
                    {{ data.item.Guidance }}
                  </template>
                </b-table>
              </div>
              <!-- Table End -->
              <hr />
            </div>
            <!-- Logs Section End -->
          </div>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { _ } from "vue-underscore";
import Vue from "vue";

export default {
  data() {
    return {
      errorLogFields: {
        LoggedAt: {
          label: "Logged At",
          sortable: true,
        },
        RecordIdentifier: {
          label: "Filename",
        },
        Message: {
          label: "Message",
        },
        Guidance: {
          label: "Guidance",
        },
      },
      d_startDate: undefined,
      d_endDate: undefined,
      submitStatus: "OK",
      selected: null,
      validated: true,
      validationResponse: null,
      filenameSearch: "",
    };
  },
  computed: {
    accessToken() {
      return this.$auth.accessToken;
    },
    xsrfToken() {
      return this.$auth.xsrfToken;
    },
    serviceBundleLogs() {
      return _.sortBy(
        this.$store.state.customers.serviceBundleLogs,
        "LoggedAt"
      ).reverse();
    },
    filteredLogs() {
      if (!this.serviceBundleLogs) return;

      let logs = this.serviceBundleLogs;

      if (this.startDate)
        logs = logs.filter((s) => this.startDate <= s.LoggedAt);

      if (this.endDate) logs = logs.filter((s) => this.endDate >= s.LoggedAt);

      if (this.filenameSearch) {
        return logs.filter((log) => {
          return this.filenameSearch
            .toLowerCase()
            .split(" ")
            .every((v) => log.RecordIdentifier.toLowerCase().includes(v));
        });
      } else {
        return logs;
      }
    },
    defaultStartDate() {
      return moment()
        .subtract(this.$config.honeycomb.signUpLogs.defaultDaysShown, "days")
        .format("YYYY-MM-DD");
    },
    startDate: {
      get() {
        return this.d_startDate
          ? moment(this.d_startDate).format("YYYY-MM-DD")
          : this.defaultStartDate;
      },

      set(val) {
        this.d_startDate = val;
      },
    },
    endDate: {
      get() {
        return (
          this.d_endDate &&
          moment(this.d_endDate).add(1, "days").format("YYYY-MM-DD")
        );
      },
      set(val) {
        this.d_endDate = val;
      },
    },
  },
  methods: {
    last30Days() {
      this.endDate = null;
      this.startDate = new Date().setTime(
        new Date().getTime() - 3600 * 1000 * 24 * 30
      );
    },
    last6Months() {
      this.endDate = null;
      this.startDate = new Date().setTime(
        new Date().getTime() - 3600 * 1000 * 24 * 180
      );
    },
    last12Months() {
      this.endDate = null;
      this.startDate = new Date().setTime(
        new Date().getTime() - 3600 * 1000 * 24 * 365
      );
    },
    resetFilter() {
      this.startDate = null;
      this.endDate = null;
    },
    processFile(event) {
      this.selected = event.target.files[0];
    },
    submit() {
      if (this.selected == null) {
        this.$snotify.warning(
          `No file selected - please select a service bundle to import.`
        );
        return false;
      }
      this.submitStatus = "PENDING";
      const fd = new FormData();
      fd.append("file", this.selected, this.selected.name);
      this.$http
        .post(
          "https://" +
            Vue.config.honeycomb.contractbot.domain +
            "/api/v1/contracts/ImportUpdates?token=" +
            this.accessToken +
            "&xsrf=" +
            this.xsrfToken,
          fd,
          {
            withCredentials: true,
          }
        )
        .catch((error) => {
          // Error
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            this.submitStatus = "Error";
            if (error.response.data.MoreInformation.length > 0) {
              error.response.data.MoreInformation.forEach((e) => {
                this.$snotify.error(`${e.Error}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              });
            } else {
              this.$snotify.error(`${error.response.data.UserDescription}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.submitStatus = "Error";
            this.$snotify.error(`No response recieved.`, {
              timeout: 0,
              closeOnClick: true,
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            this.submitStatus = "Error";
            this.$snotify.error(`${error.message}`, {
              timeout: 0,
              closeOnClick: true,
            });
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.$store.dispatch('getServiceBundleLogs').then(()=>{
            this.submitStatus = "OK";
            this.$snotify.info(`Service bundle imported.`);
            this.selected = null;
            this.validated = false;
            this.$refs["file-input"].reset();
            })
        }, 3000);
        });
    },
  },
};
</script>
